// @flow

import React, { Component } from "react";

import PostWidgetChatBubble from "./post-widget-chat-bubble";
import PostWidgetInfoSection from "./post-widget-info-section";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Icons } from "../../index";
import RadioHierarchyTree from "../../radio-hierarchy-tree";
import type { RadioWidget as RadioWidgetProps } from "react-jsonschema-form/lib/components/widgets/RadioWidget";
import { flattenNodes, type FlatNodes } from "../../base-hierarchy-tree/util";

type Props = $Exact<{
  ...RadioWidgetProps,
  options: Object,
}>;

type ComponentState = $Exact<{
  isOpen: boolean,
  selected: number | null,
}>;

class RadioHierarchyTreeModalWidget extends Component<Props, ComponentState> {
  state = {
    isOpen: false,
    selected: null,
  };

  flatNodes: FlatNodes;

  constructor(props: Props) {
    super(props);

    if (props.schema.tree) {
      this.flatNodes = flattenNodes(props.schema.tree);
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.value !== this.props.value) {
      this.setState({
        selected: this.props.value,
      });
    }

    if (prevProps.schema.tree !== this.props.schema.tree) {
      this.flatNodes = flattenNodes(this.props.schema.tree);
    }
  }

  handleChange = () => {
    this.props.onChange(this.state.selected);
    this.closeModal();
  };

  showModal = () => {
    this.setState({
      isOpen: true,
    });
  };

  closeModal = () => {
    this.setState({
      isOpen: false,
    });
  };

  handleHierarchyTreeChange = (value: number) => {
    this.setState({
      selected: value,
    });
  };

  get selectedLabel(): string {
    if (!this.props.value || !this.flatNodes) {
      return "";
    }

    return this.flatNodes[this.props.value].label;
  }

  render() {
    return (
      <React.Fragment>
        <div className="input-icon-right" onClick={this.showModal}>
          <Input
            className="w-100"
            placeholder={this.props.options.inputPlaceholder}
            value={this.selectedLabel}
          />
          <Icons.ThreePersons2Icon
            className="tree-icon radio-hierarchy-tree-input"
            color="coffee-d3"
          />
        </div>
        <PostWidgetChatBubble options={this.props.options} />
        <PostWidgetInfoSection options={this.props.options} />
        {this.state.isOpen && (
          <Modal className="nano-modal">
            <ModalHeader toggle={this.closeModal}>{this.props.options.modalTitle}</ModalHeader>
            <ModalBody>
              <RadioHierarchyTree
                searchable={!!this.props.options.searchable}
                searchPlaceholder={this.props.options.searchPlaceholder}
                tree={this.props.schema.tree}
                selected={this.state.selected}
                disabled={this.props.readonly}
                onChange={this.handleHierarchyTreeChange}
                expanded={[]}
              />
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={this.closeModal}>
                {this.props.options.cancelButtonTitle}
              </Button>
              <Button onClick={this.handleChange}>{this.props.options.submitButtonTitle}</Button>
            </ModalFooter>
          </Modal>
        )}
      </React.Fragment>
    );
  }
}

export default RadioHierarchyTreeModalWidget;
